<template>
  <div class="service-welfare">
    <div class="welfare-banner">
      <div class="welfare-title EC5 center">知链公益</div>
    </div>
    <div class="explan-wrap w1200">
      <div class="welfare-plan flex-row-reverse">
        <div class="welfare-plan-right">
          <img :src="require('@/assets/images/service3.jpg')" alt="" />
        </div>
        <div class="welfare-plan-left">
          <p>知链公益计划</p>
          <div class="tips">
            旨在通过技术与服务，普惠优质教育资源，培育更多的人才。帮助公益机构将公益服务零门槛转至线上，降低公益组织技术成本，渠道开发成本，加快公益组织服务效率，让公益组织有更多精力投入到教育公益、非物质文化遗产传承等事业当中，真正实现“科技助力每个孩子成才”的美好愿景。
          </div>
        </div>
      </div>
      <div class="welfare-plan">
        <div class="welfare-plan-left">
          <img :src="require('@/assets/images/service4.png')" alt="" />
        </div>
        <div class="welfare-plan-right">
          <p>扶持政策</p>
          <div class="tips-list">
            <div class="item-tip">
              <img :src="require('@/assets/images/service11.png')" alt="" />
              <span>公开课直播流量资费全额补贴</span>
            </div>
            <div class="item-tip">
              <img :src="require('@/assets/images/service12.png')" alt="" />
              <span>在线客服随时响应</span>
            </div>
            <div class="item-tip">
              <img :src="require('@/assets/images/service13.png')" alt="" />
              <span>标准版店铺免费使用</span>
            </div>
            <div class="item-tip">
              <img :src="require('@/assets/images/service14.png')" alt="" />
              <span>运营人才线上免费培训</span>
            </div>
          </div>
        </div>
      </div>
    </div>
   
    <div class="public-welfare-bottom">
      <div class="content-wrap">
        <div>
          <p class="title">知链公益计划</p>
          <a
            target="_blank"
            class="btn"
            href="#"
            data-sensors="公益计划页_产品_底部-立即申请"
            data-count="pc端-公益计划_底部_立即申请"
            >立即申请</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">
.service-welfare {
  .welfare-title {
    margin-bottom: 40px;
    font-size: 66px;
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .welfare-banner {
    height: 360px;
    padding-top: 160px;
    background: url('~@/assets/images/service2.jpg') center no-repeat;
    background-size: cover;
  
  }
  .explan-wrap .welfare-plan .welfare-plan-left p,
  .explan-wrap .welfare-plan .welfare-plan-right p {
    font-weight: 500;
    font-family: SourceHanSansCN-Medium;
    margin-bottom: 48px;
    font-size: 30px;
  }
  .explan-wrap .welfare-plan {
    display: flex;
    overflow: hidden;
    height: 350px;
    padding: 0 47px;
    margin-top: 190px;
  }
  .explan-wrap .welfare-plan .welfare-plan-left {
    width: 553px;
  }
  .explan-wrap .welfare-plan .welfare-plan-left .tips {
    color: #333;
    width: 377px;
    line-height: 36px;
  }
  .explan-wrap .welfare-plan .welfare-plan-left img {
    display: inline-block;
    width: 100%;
  }
  .explan-wrap .welfare-plan .welfare-plan-right {
    width: 553px;
    position: relative;
  }
  .explan-wrap .welfare-plan .welfare-plan-right p {
    text-align: center;
  }
  .explan-wrap .welfare-plan .welfare-plan-right img {
    display: inline-block;
    width: 100%;
  }
  .explan-wrap .welfare-plan .welfare-plan-right .tips-list {
    width: 240px;
    position: absolute;
    top: 76px;
    left: 20px;
    bottom: 0;
    right: 0;
    margin: 0 auto;
  }
  .explan-wrap .welfare-plan .welfare-plan-right .tips-list .item-tip {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
  .explan-wrap .welfare-plan .welfare-plan-right .tips-list .item-tip img {
    width: 40px;
    height: 40px;
    display: inline-block;
    margin-right: 16px;
  }
  .join-list-wrap {
    margin-top: 170px;
  }
  .join-list-wrap .title {
    text-align: center;
    color: #333;
    font-size: 30px;
    font-family: Adobe Heiti Std R;
  }
  .join-list-wrap .join-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 60px;
    overflow: hidden;
  }
  .join-list-wrap .join-list .item-wrap {
    font-family: MicrosoftYaHei;
    text-align: center;
    padding: 40px 24px;
    width: 23%;
    margin: 0 1% 37px;
    height: 460px;
    border: 1px solid #f5f5f5;
    -webkit-box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 5px 15px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;
  }
  .join-list-wrap .join-list .item-wrap .item-tip-title {
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 18px;
  }
  .join-list-wrap .join-list .item-wrap .item-tip-content {
    color: #666;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
  }
  .application-process-wrap .content-wrap {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .application-process-wrap .content-wrap > div,
  .public-welfare-bottom .content-wrap > div {
    color: #fff;
    text-align: center;
  }
  // .join-list-wrap .join-list .item-wrap:last-child,
  // .join-list-wrap .join-list .item-wrap:nth-child(4) {
  //   margin-right: 0;
  // }
  .application-process-wrap {
    margin-top: 180px;
    height: 400px;
    background: url('~@/assets/images/service15.png') center no-repeat;
    background-size: cover;
    position: relative;
  }
  .application-process-wrap .content-wrap > div .title {
    font-size: 30px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  .application-process-wrap .content-wrap > div .tips {
    font-size: 13px;
    margin-bottom: 40px;
  }
  .review-wrap {
    margin-top: 100px;
    text-align: center;
  }
  .review-wrap .title {
    font-size: 30px;
    font-weight: 400;
    margin-bottom: 20px;
  }
  .review-wrap .tips {
    font-size: 14px;
    margin-bottom: 60px;
    line-height: 24px;
  }
  .review-wrap .certificate-list .item-certificate {
    display: inline-block;
    margin-right: 140px;
  }
  .review-wrap .certificate-list .item-certificate > p {
    margin-top: 24px;
  }
  .review-wrap .certificate-list .item-certificate:last-child {
    margin-right: 0;
  }
}
.app .service-welfare {
  padding-top: 1.04rem;
  .public-welfare {
    background: none;
    text-align: center;
    height: auto;
    img {
      max-width: 100%;
    }
  }
  .explan-wrap .welfare-plan {
    display: block;
    height: auto;
    margin: 0;
    padding: 0;
    .welfare-plan-right,
    .welfare-plan-left {
      width: auto;
      text-align: center;
      img {
        width: 5.53rem;
        height: 3.5rem;
        margin: 1.17rem 0 0.84rem;
      }
    }
    .welfare-plan-left,
    .welfare-plan-right {
      width: auto;
      text-align: center;
      margin-bottom: 0.36rem;
      padding: 0 1.04rem 0 0.88rem;
      font-size: 0.28rem;
      line-height: 0.5rem;
      p {
        margin-bottom: 0.54rem;
        font-size: 0.45rem;
        font-weight: 500;
      }
      .tips {
        width: auto;
        line-height: 0.5rem;
      }
      .tips-list {
        position: static;
        margin: 0 auto 1.47rem;
        width: 4.8rem;
        .item-tip {
          margin-bottom: 0.4rem;
          font-size: 0.28rem;
          align-items: center;
          img {
            width: 0.6rem;
            height: 0.6rem;
            margin: 0 0.41rem 0 0;
          }
        }
      }
    }
  }
  .join-list-wrap {
    margin-top: 0;
    margin-bottom: 1.52rem;
    .title {
      margin-bottom: 0.54rem;
      font-size: 0.45rem;
      font-weight: 500;
    }
    .join-list {
      padding: 0 0.36rem;
      .item-wrap {
        padding-top: 0.47rem;
        margin: 0 0 0.2rem;
        width: 3.2rem;
        height: 6.57rem;
        text-align: center;
        border: 0.01rem solid #f5f5f5;
        -webkit-box-shadow: 0 0.1rem 0.15rem 0 rgba(0, 0, 0, 0.1);
        box-shadow: 0 0.1rem 0.15rem 0 rgba(0, 0, 0, 0.1);
        border-radius: 0.06rem;
        img {
          width: 2.2rem;
          height: 1rem;
        }
        .item-tip-title {
          margin: 0.23rem auto;
          font-size: 0.3rem;
          color: #000;
          font-weight: 400;
        }
        .item-tip-content {
          padding: 0 0.29rem;
          font-size: 0.24rem;
          color: #666;
          line-height: 0.35rem;
          text-align: justify;
        }
      }
    }
  }
  .application-process-wrap {
    padding: 0.8rem 0;
    margin-bottom: 1.53rem;
    width: 100%;
    height: 4.72rem;
    .content-wrap > div {
      .title {
        margin: 0 auto 0.6rem;
        font-size: 0.45rem;
      }
    }
    img {
      width: 750px;
      max-width: 100%;
    }
  }
  .review-wrap {
    margin-top: 1.53rem;
    .title {
      margin-bottom: 0.54rem;
      font-size: 0.45rem;
      font-weight: 500;
    }
    .tips {
      padding: 0 0.21rem;
      font-size: 0.24rem;
      margin-bottom: 0.36rem;
      color: #333;
      line-height: 0.5rem;
      text-align: justify;
    }
  }
  .certificate-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 0.76rem 0 1.5rem;
    padding: 0 0.66rem 0 0.41rem;
    .item-certificate {
      margin: 0 0 0.66rem;
      color: #333;
      font-size: 0.24rem;
      img {
        margin-bottom: 0.23rem;
        width: 2.67rem;
        height: 1.85rem;
      }
      p {
        margin: 0;
        font-size: 0.24rem;
      }
    }
  }
  .public-welfare-bottom {
    width: 100%;
    height: 2.94rem;
    padding-top: 0.73rem;
    .content-wrap {
      position: static;
    }
  }
  .public-welfare-bottom .content-wrap > div .title {
    font-size: 0.45rem;
    margin: 0;
  }
  .public-welfare-bottom .content-wrap > div a {
    margin: 0.36rem auto 0;
    display: block;
    width: 2.92rem;
    height: 0.84rem;
    line-height: 0.84rem;
    font-size: 0.32rem;
    border-radius: 0.08rem;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    background-color: #fff;
    color: #1472ff;
    text-align: center;
    border: 0.02rem solid #fff;
  }
}
</style>
